import { useCallback } from "react";
import {
  MerchantSegmentAnalyticsAdapter,
  useMerchantSegmentAnalytics,
} from "./useMerchantSegmentAnalytics";

type OneTrustCookieMissingEventName = "Error Reported";

type OneTrustCookieMissingTrack = (
  eventName: OneTrustCookieMissingEventName,
  properties: Record<string, unknown>,
) => Promise<unknown> | void;

interface UseMerchantOneTrustSegmentOptions<
  T extends MerchantSegmentAnalyticsAdapter & {
    track: OneTrustCookieMissingTrack;
  },
> {
  performanceAllowed: boolean;
  merchantId?: string;
  pathname?: string | null;
  load: (writeKey: string) => T;
}

export const useMerchantOneTrustSegment = <
  T extends MerchantSegmentAnalyticsAdapter & {
    track: OneTrustCookieMissingTrack;
  },
>({
  performanceAllowed,
  merchantId,
  pathname,
  load,
}: UseMerchantOneTrustSegmentOptions<T>) => {
  const writeKey = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY || "";
  const analytics = useMerchantSegmentAnalytics<T>({
    writeKey,
    performanceAllowed,
    merchantId,
    pathname,
    load,
  });

  const trackOneTrustCookieMissing: OneTrustCookieMissingTrack = useCallback(
    (eventName, properties) => analytics?.track(eventName, properties),
    [analytics],
  );

  return {
    analytics,
    trackOneTrustCookieMissing,
    writeKey,
  };
};
